import * as EmployeeActions from './EmployeeActions.js';

const initialState = {
  employees: [],
  workingHours: [],
  customHours: []
};

export default function employee(state = initialState, action) {
  switch (action.type) {
    case 'UNAUTHORIZED':
      return {
        ...initialState
      };
    case 'LOGOUT':
      return {
        ...initialState
      };
    case EmployeeActions.LOAD_EMPLOYEES:
      return {
        ...state,
        employees: action.data.employees
      };
    case EmployeeActions.LOAD_WORKING_HOURS:
      return {
        ...state,
        workingHours: action.data.working_hours
      };
    case EmployeeActions.LOAD_CUSTOM_HOURS:
      return {
        ...state,
        customHours: action.data.one_off_hours
      };
    default:
      return state;
  }
}

export function getEmployeeName(employeeId, employees) {
  if (!employees) return null;
  const e = employees.filter(e => e.id === employeeId)[0];
  return e ? e.name : null;
}
